function currencyFormat(num: number) {
    //1234567 => $1,234,567
    if (num) {
        const newNum = '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        return (newNum).substring(0, newNum.length - 3);
    } else {
        return "";
    }
    
}

function setSessionExpiry() : number {
    const storageToken = localStorage.getItem("sessionExp");
    if (storageToken) {
        const expTime = parseInt(storageToken);
        if (!isNaN(expTime)) {
            const currentTime = Date.now();
            if (currentTime < (expTime * 1000)) {
                return expTime * 1000 - currentTime;
            }
        }        
    }
    return -1;
}

function setSessionExpiryReg() : number {
    const storageToken = localStorage.getItem("regExp");
    if (storageToken) {
        const expTime = parseInt(storageToken);
        if (!isNaN(expTime)) {
            const currentTime = Date.now();
            if (currentTime < (expTime * 1000)) {
                return expTime * 1000 - currentTime;
            }
        }        
    }
    return -1;
}

function setSessionExpiryWarning() : number {
    const storageToken = localStorage.getItem("sessionExp");
    if (storageToken) {
        const expTime = parseInt(storageToken);
        if (!isNaN(expTime)) {
            const currentTime = Date.now();
            if (currentTime < (expTime * 1000)) {
                // 10 minute warning
                return (expTime * 1000 - currentTime) - 900000;
            }
        }        
    }
    return -1;
}

export { currencyFormat, setSessionExpiry, setSessionExpiryWarning, setSessionExpiryReg };